<div class="toolbar-wrapper" [class.sidebar-layout]="isMobileOrTablet">
  <!-- Desktop: Top toolbar -->
  <mat-toolbar class="main-toolbar" *ngIf="!isMobileOrTablet">
    <mat-toolbar-row class="layout-container">
      <span class="logo-wrapper">
        <img
          class="logo"
          src="../../../../../assets/icons/icon_astra.svg"
          alt="logo"
        />
      </span>
      <span class="app-name">ROPA</span>
    </mat-toolbar-row>
  </mat-toolbar>

  <!-- Mobile/Tablet: Sidebar navigation -->
  <div class="sidebar-nav" *ngIf="isMobileOrTablet">
    <!-- Logo and app name -->
    <div class="sidebar-header">
      <span class="logo-wrapper">
        <img
          class="logo"
          src="../../../../../assets/icons/icon_astra.svg"
          alt="logo"
        />
      </span>
      <span class="app-name">ROPA</span>
    </div>
  </div>
</div>
